import { setFileApiSource, setFileApiTicket, getUploadConfigNew, getGroupList, getMainServerList, getUploadLimit } from './service';
import { getMixDeploymentInfo } from './service';
import { NetworkInfo } from './utils';
import { loadScript } from 'yxt-biz-pc/src/utils/util';

export default {
  data() {
    return {
      customSelectUploadEnv: 0,
      uploadSettingDialogVisible: false,
      cacheCurrSelectFiles: [],
      uploadCloudRadio: 0,
      fileLimitCongig: null,
      groupListRes: null,
      selectLocalServiceId: null,
      settingConfigLoadingSuccess: false
    };
  },
  methods: {
    async v2CreatedInit() {
      console.log('--- v2 版本 ---');
      // 必须设置为fasle，防止使用方自己传了true
      this.isLocal = false;
      this.computedFileTranscode();
      // 如果使用上传组件时传入source，则覆盖项目引用业务组件时传入的source
      this.source && setFileApiSource(this.source);

      // 设置上传时接口tickect参数
      this.ticket && setFileApiTicket(this.ticket);

      this.tencentQueue = {}; // 腾讯云文件上传队列
      this.baiduQueue = {}; // 百度云、私有云文件上传队列
      this.networkInfo = new NetworkInfo(); // 上传队列网络信息
      await loadScript(window.feConfig && window.feConfig.common && window.feConfig.common.uploadConfig || 'https://media-phx.yunxuetang.com.cn/dynamic/common/upload-config-keys.js');
      // 获取上传限制配置
      const limitConfig = await getUploadLimit({ orgId: window.localStorage.orgId, configKey: this.configKey });
      const cdnFileConfig = window.uploadConfigKeys[this.configKey] || {}; // 这是cdn上的上传限制配置参数
      let fileLimitCongig = {}; // 文件大小限制与filters配置信息
      if (!limitConfig) {
        // 没有就采用cdn上的
        fileLimitCongig = { ...cdnFileConfig };
      } else {
        // 由于获取的配置参数是string类型，先做一次处理
        for (const key in limitConfig) {
          if (Object.hasOwnProperty.call(limitConfig, key)) {
            const value = limitConfig[key];
            if (/^[0-9]+$/.test(value)) {
              fileLimitCongig[key] = Number(value);
            }
          }
        }
        // 验证有没有开启 isOpen 公开空间配置
        if (this.isOpen) {
          fileLimitCongig.isOpen = true;
        } else {
          // 如果组件没配置则默认使用cdn配置中的参数
          fileLimitCongig.isOpen = cdnFileConfig.isOpen;
        }
        // 验证有没有配置上传文件限制
        if (this.filters) {
          fileLimitCongig.filters = this.filters;
        } else {
          // 没传就采用cdn上的配置
          fileLimitCongig.filters = cdnFileConfig.filters || '*';
        }
      }
      this.fileLimitCongig = fileLimitCongig;
      await this.getMixUploadSetting(fileLimitCongig);
    },
    async getMixUploadSetting(fileLimitCongig) {
      this.canUpload = true;
      const MixDeployInfo = await getMixDeploymentInfo(window.localStorage.getItem('orgId'), this.sceneCode);
      const groupListRes = await getGroupList();
      if (groupListRes && groupListRes.serviceGroupList && groupListRes.serviceGroupList.length) {
        // 默认为私有云服务组第一个
        this.selectLocalServiceId = groupListRes.serviceGroupList[0].id;
      }
      this.groupListRes = groupListRes;
      const { localSwith, sceneConfigReq } = MixDeployInfo;
      if (localSwith === 1) {
        // 开启了私有化
        this.isLocal = true;
        if (!sceneConfigReq) {
          // 没有配置项，走公有云逻辑
          this.publicConfigInfo(fileLimitCongig);
          return;
        }
        if (sceneConfigReq.configValue === '0') {
          // 表示只传到公有云
          this.customSelectUploadEnv = 0;
          this.publicConfigInfo(fileLimitCongig);
          return;
        }
        if (sceneConfigReq.configValue === '1') {
          // 表示只传到私有云
          this.uploadCloudRadio = 1;
          if (groupListRes && groupListRes.serviceGroupList && groupListRes.serviceGroupList.length > 1) {
            // 只有在服务器组大于1个的时候，私有云场景才会弹出选择框
            this.customSelectUploadEnv = 1;
          }
          this.localConfigInfo(fileLimitCongig, this.groupListRes, this.selectLocalServiceId);
          return;
        }
        if (sceneConfigReq.configValue === '2') {
          this.customSelectUploadEnv = 2;
          return;
        }
      } else {
        // 没开启直接走公有云逻辑
        this.publicConfigInfo(fileLimitCongig);
      }
    },
    async publicConfigInfo(fileLimitCongig) {
      this.settingConfigLoadingSuccess = false;
      this.isLocal = false;
      this.groupId = '';
      const publicConfig = await getUploadConfigNew();
      this.uploadConfig = {
        ...publicConfig,
        ...fileLimitCongig
      };
      this.cloudType = 'publicCloud';
      window.cloudType = this.cloudType;
      this.isLocalApi = false;
      this.settingConfigLoadingSuccess = true;
      if (this.onReady) {
        this.$nextTick(this.onReady);
      }
    },
    async localConfigInfo(fileLimitCongig, groupListRes, selectLocalServiceId) {
      this.isLocal = true;
      this.isLocalApi = true;
      this.settingConfigLoadingSuccess = false;
      this.cloudType = 'local';

      if (!groupListRes.localUploadConfig || !groupListRes.localUploadConfig.secretDomain) {
        console.error('混部 私有化场景下未正确配置私有化域名, 请检查123平台配置');
        this.settingConfigLoadingSuccess = false;
        return;
      }
      this.uploadConfig = {
        ...groupListRes.localUploadConfig,
        ...fileLimitCongig
      };
      this.uploadConfig.localConfig = groupListRes.localUploadConfig;
      this.uploadConfig.local = groupListRes.localUploadConfig;
      this.uploadConfig.serviceGroupList = groupListRes.serviceGroupList;
      const mainServerListRes = await getMainServerList(selectLocalServiceId);
      // 取出启用中的服务器
      const result = mainServerListRes.filter(item => {
        return item.serviceType === '1';
      });
      this.groupId = result.length ? result[0].id : (mainServerListRes.length ? mainServerListRes[0].id : 0);
      this.publicReadHost = result.length ? result[0].trascodeHost : ''; // 私有云公开空间访问地址
      this.settingConfigLoadingSuccess = true;
      console.log(this.groupId, this.publicReadHost);
    },
    async handleUploadSetting() {
      if (this.cacheCurrSelectFiles) {
        console.log(this.uploadCloudRadio, this.cacheCurrSelectFiles);
        switch (this.uploadCloudRadio) {
          case 0:
            await this.publicConfigInfo(this.fileLimitCongig);
            break;
          case 1:
            await this.localConfigInfo(this.fileLimitCongig, this.groupListRes, this.selectLocalServiceId);
            break;
          default:
            await this.publicConfigInfo(this.fileLimitCongig);
            break;
        }
        if (this.settingConfigLoadingSuccess) {
          // 所有配置全部加载成功
          this.bceUploader = null;
          this.uploadFiles(this.cacheCurrSelectFiles);
          this.cacheCurrSelectFiles = null;
          this.uploadSettingDialogVisible = false;
        }
      }
    }
  }
};
